import React from 'react'

import Achuth from '../images/Achuth-Gowda.jpeg'
import Shubha from '../images/Subhalakshmi.jpg'
import Pooja from '../images/Pooja.jpeg'

import stand1 from '../images/stand_out/service_offering.png'
import stand2 from '../images/stand_out/experienced_professionals.png'
import stand3 from '../images/stand_out/hassle_execution.png'
import stand4 from '../images/stand_out/diverse_offering.png'
import stand5 from '../images/stand_out/client_testimonials.png'




function WhyUs() {


  
  return (
    <div className='w-full h-full overflow-hidden'>
        <div className='min-h-[180px] bg-red-100  relative md:min-h-[240px] 2xl:min-h-[200px] bg-cover bg-center bg-right-top md:bg-cover bg-no-repeat w-full bg-why_us_bg'>
          <div data-aos="fade-left" className='absolute top-[5%] md:top-[15%]  w-[75%] md:w-[35%]' >
          {/* <Typist avgTypingDelay={15} stdTypingDelay={15}> */}
            <div className='border-l w-full border-l-4  border-l-[#4190ac] ml-[6%] pl-[1.5%] absolute top-[15%]'>
                <h6 className='text-[18px] font_thicker md:text-[21px] text-[#fff] font-[800]  '>Why Believe in us</h6>
                <h6 className='text-[13px] font_normal md:text-[14px] text-[#fff]'>we work hard to add care and value for your place. and we would be able to make it happen with your support! </h6>
            </div>
          {/* </Typist>   */}
          </div>
        </div>

        <div className='pt-10 md:pt-20'>
            <h6 data-aos="fade-left" data-aos-delay="300" className='group font_thicker text-center text-[21px] 2xl:text-[24px]'>Why  <span className='text-[#4190ac]'>Us</span></h6>
            <div data-aos="fade-right" data-aos-delay="300" className='flex items-center justify-center w-full mt-1'>
            <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
            <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
            </div> 
            <h6 data-aos="fade-left" className='text-center font_normal mt-2 text-slate-800 w-[90%] md:w-[70%] mx-auto text-[14.5px] 2xl:text-[17.5px]'>Meet our exceptional team of professionals who are passionate about elevating facility management standards. With their skills and dedication, we guarantee seamless execution and utmost client satisfaction.</h6>

            <div data-aos="fade-left" className='w-[90%] md:w-[80%] mx-auto py-20'>
            <h6 data-aos="fade-up" className='text-[18px] 2xl:text-[21px] text-slate-600 font_thicker '>Our Key Differentiators:</h6>  
            <ul data-aos="fade-up" className="my-10 ml-10 list-disc text-slate-800">

  <li className="text-[13.5px] 2xl:text-[16.5px] mb-3 font_normal">
    <span className="text-slate-600 font_thicker">
      Skilled & Trained Workforce:
    </span>{" "}
    We deploy manpower that is trained, disciplined, and aligned with your operational standards.
  </li>

  <li className="text-[13.5px] 2xl:text-[16.5px] mb-3 font_normal">
    <span className="text-slate-600 font_thicker">
      Structured Operations:
    </span>{" "}
    Defined processes, clear responsibilities, and active supervision ensure smooth daily functioning.
  </li>

  <li className="text-[13.5px] 2xl:text-[16.5px] mb-3 font_normal">
    <span className="text-slate-600 font_thicker">
      PAN India Capability:
    </span>{" "}
    We support businesses across multiple cities with consistent service quality and fast deployment.
  </li>

  <li className="text-[13.5px] 2xl:text-[16.5px] mb-3 font_normal">
    <span className="text-slate-600 font_thicker">
      Performance-Driven Approach:
    </span>{" "}
    Our focus is not just service delivery—but improving efficiency, productivity, and outcomes.
  </li>

  <li className="text-[13.5px] 2xl:text-[16.5px] mb-3 font_normal">
    <span className="text-slate-600 font_thicker">
      Scalable Solutions:
    </span>{" "}
    Whether single location or multi-location operations, we scale with your business needs.
  </li>

  <li className="text-[13.5px] 2xl:text-[16.5px] mb-3 font_normal">
    <span className="text-slate-600 font_thicker">
      Compliance & Reliability:
    </span>{" "}
    We maintain strong adherence to operational standards, safety, and workforce discipline.
  </li>

</ul>

            <h6 data-aos="fade-up" className='text-[18px] 2xl:text-[21px] mt-10 text-slate-600 font_thicker '>The Difference We Create:</h6> 

            <ul data-aos="fade-up" className="my-10 ml-10 list-disc text-slate-800">

<li className="text-[13.5px] 2xl:text-[16.5px] mb-2 font_normal">
  Reduced operational gaps.
</li>

<li className="text-[13.5px] 2xl:text-[16.5px] mb-2 font_normal">
  Improved workplace efficiency.
</li>

<li className="text-[13.5px] 2xl:text-[16.5px] mb-2 font_normal">
  Reliable and accountable workforce.
</li>

<li className="text-[13.5px] 2xl:text-[16.5px] mb-2 font_normal">
  Better managed and structured environments.
</li>

<li className="text-[13.5px] 2xl:text-[16.5px] mb-2 font_normal">
  Peace of mind for business owners.
</li>

</ul>
            <h6 data-aos="fade-right" className='text-[14.5px] 2xl:text-[17.5px] text-slate-800 font_normal break-word'>Fidelitus FMS is built on a foundation of trust, discipline, and commitment to excellence. We focus on long-term partnerships by consistently delivering reliable services that businesses can depend on—day after day..</h6>
            </div>
         </div>

    </div>
  )
}

export default WhyUs